import { getRequest, postRequest } from "./ApiInstence";

// Save device token to backend
export const saveDeviceTokenApi = (data) =>
  postRequest("device/save-token/", data);

// Get notifications
export const getNotificationsApi = () =>
  getRequest("notifications/");

// Mark notification read
export const markNotificationReadApi = (id) =>
  postRequest(`notifications/read/${id}/`);
